import * as React from 'react';
import {FunctionComponent} from 'react';

import trend_falling from '../assets/icons/trend_falling.svg';
import trend_growing from '../assets/icons/trend_growing.svg';
import {Trend} from '../swagger';

export interface TrendProps {
    imgHeight?: string;
    trend?: Trend;
}

export const TrendView: FunctionComponent<TrendProps> = ({imgHeight, trend}) => (
    <React.Fragment>
        {trend === Trend.Down && (
            <img
                alt="Falling trend"
                src={trend_falling}
                style={{height: imgHeight ? imgHeight : '1.25rem'}}
                title="Today there are less errors than yesterday"
            />
        )}
        {trend === Trend.Up && (
            <img
                alt="Growing trend"
                src={trend_growing}
                style={{height: imgHeight ? imgHeight : '1.25rem'}}
                title="Today there are more errors than yesterday"
            />
        )}
    </React.Fragment>
);
